import { render, staticRenderFns } from "./focus-words-chapter-header-actions.vue?vue&type=template&id=2c1f87fa&scoped=true"
import script from "./focus-words-chapter-header-actions.ts?vue&type=script&lang=ts&external"
export * from "./focus-words-chapter-header-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./focus-words-chapter-header-actions.less?vue&type=style&index=0&id=2c1f87fa&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f87fa",
  null
  
)

export default component.exports